var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1998 21.9031C21.1998 22.2888 20.8862 22.6031 20.4998 22.6031H13.4998C13.1134 22.6031 12.7998 22.2888 12.7998 21.9031V14.2031H21.1998V21.9031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9002 20.4969C15.2852 20.4969 15.6002 20.1819 15.6002 19.7969V16.9969C15.6002 16.6119 15.2852 16.2969 14.9002 16.2969C14.5152 16.2969 14.2002 16.6119 14.2002 16.9969V19.7969C14.2002 20.1819 14.5152 20.4969 14.9002 20.4969Z",
    fill: "#4E6088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1004 20.4969C19.4854 20.4969 19.8004 20.1819 19.8004 19.7969V16.9969C19.8004 16.6119 19.4854 16.2969 19.1004 16.2969C18.7154 16.2969 18.4004 16.6119 18.4004 16.9969V19.7969C18.4004 20.1819 18.7154 20.4969 19.1004 20.4969Z",
    fill: "#4E6088"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3 12.8H22.6H19.8V11.6296C19.8 10.7308 19.0153 10 18.05 10H15.95C14.9847 10 14.2 10.7308 14.2 11.6296V12.8H11.4H10.7C10.315 12.8 10 13.115 10 13.5C10 13.885 10.315 14.2 10.7 14.2H11.4V21.9C11.4 23.0578 12.3422 24 13.5 24H20.5C21.6578 24 22.6 23.0578 22.6 21.9V14.2H23.3C23.685 14.2 24 13.885 24 13.5C24 13.115 23.685 12.8 23.3 12.8ZM21.2 21.9C21.2 22.2857 20.8864 22.6 20.5 22.6H13.5C13.1136 22.6 12.8 22.2857 12.8 21.9V14.2H21.2V21.9ZM15.95 11.4C15.7498 11.4 15.6 11.5211 15.6 11.6296V12.8H18.4V11.6296C18.4 11.5211 18.2502 11.4 18.05 11.4H15.95Z",
    fill: "#4E6088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.2eb693be3f1954dac8af07c3f2938953.svg";
export { ForwardRef as ReactComponent };